// Single source of truth for form fields. Mirrors backend Pydantic models
// (QuoteCreate / CarrierCreate / ContactCreate in backend/server.py).
export const FORM_SCHEMAS = {
  quote: {
    path: "quotes",
    fields: ["company", "contact_name", "email", "phone", "origin",
             "destination", "freight_type", "weight", "notes"],
    controlled: ["service", "pickup_date"],
  },
  carrier: {
    path: "carriers",
    fields: ["company", "contact_name", "email", "phone", "mc_number",
             "dot_number", "equipment", "fleet_size", "lanes"],
    controlled: [],
  },
  contact: {
    path: "contact",
    fields: ["name", "email", "company", "message"],
    controlled: [],
  },
};

export function buildPayload(kind, formEl, controlled = {}) {
  const schema = FORM_SCHEMAS[kind];
  if (!schema) throw new Error(`Unknown form kind: ${kind}`);
  const payload = {};
  for (const name of schema.fields) {
    const el = formEl.elements.namedItem(name);
    if (!el) throw new Error(`Form "${kind}" is missing field "${name}"`);
    payload[name] = el.value;
  }
  for (const name of schema.controlled) {
    if (!(name in controlled))
      throw new Error(`Form "${kind}" missing controlled value "${name}"`);
    payload[name] = controlled[name];
  }
  return payload;
}
